module.exports = __webpack_public_path__ + "static/media/bg7.8cb90f13.jpg";